import { BulkActionsBarOutlet, BulkActionsBarProvider } from '@calendly/ui/components/bulk-actions-bar';
import { PageHeaderContext, PageHeaderOutlet } from '@calendly/ui/components/page-header';
import classNames from 'classnames';
import { ReactNode, RefCallback } from 'react';
import { StickyFooterContext, StickyFooterOutlet } from 'features/layout';
import { SeatRequestsBanner } from 'features/seat_requests';
import { TermsOfService } from 'features/terms_of_service';
import { CenterPanelContent } from './CenterPanelContent';
import { CenterPanelLayoutProvider } from './centerPanelLayoutContext';
import { PageFilterContext, PageFilterOutlet } from './pageFilterContext';
const centerPanelContainerCss = "ci8rqzu";
const topChromeCss = "t1lwhhm2";
const bottomChromeCss = "bfnhjpz";
interface CenterPanelProps {
  /** Ref callback from `MainContainerSizeProvider` — attach to the main element to enable size tracking. */
  sizeRef?: RefCallback<HTMLElement>;
  children: ReactNode;
  className?: string;
  'aria-hidden'?: boolean;
}

/**
 * Primary content column in the app shell body row.
 * Owns the page header, filter bar, scrollable content region (`CenterPanelContent`), sticky footer, and bulk-actions bar.
 * Also provides layout context (`CenterPanelLayoutProvider`) so child routes can opt into wide mode.
 *
 * `sizeRef` must be provided by a `MainContainerSizeProvider` ancestor so that container-size
 * context is available to both this panel and its siblings (e.g. the side panel / right rail).
 *
 * @param sizeRef - Ref callback from `MainContainerSizeProvider`; attached to the `<main>` element.
 * @param children - Page content rendered inside the scrollable region.
 * @param className - Additional class applied to the outer container (e.g. shared `bodyPanelCss` border-radius).
 */
export const CenterPanel = ({
  sizeRef,
  children,
  className,
  'aria-hidden': ariaHidden
}: CenterPanelProps) => <CenterPanelLayoutProvider>
    <PageHeaderContext>
      <PageFilterContext>
        <BulkActionsBarProvider>
          <StickyFooterContext>
            <main ref={sizeRef} className={classNames(className, centerPanelContainerCss)} data-component="main" id="shell-content" aria-hidden={ariaHidden}>
              <div className={topChromeCss} id="shell-content-header">
                <TermsOfService />
                <SeatRequestsBanner />
                <PageHeaderOutlet />
                <PageFilterOutlet />
              </div>
              <CenterPanelContent>
                {children}
              </CenterPanelContent>
              <div className={bottomChromeCss}>
                <StickyFooterOutlet />
                <BulkActionsBarOutlet />
              </div>
            </main>
          </StickyFooterContext>
        </BulkActionsBarProvider>
      </PageFilterContext>
    </PageHeaderContext>
  </CenterPanelLayoutProvider>;

require("./CenterPanel.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CenterPanel.tsx");